const cryptoJs = require('crypto-js');

const cryptoKey = "U2FsdGVkX1+JPpuH6kBmbEAxOGa5N6AuyCHF4LHhcSA=";

function Decrypt(data) {
  return cryptoJs.AES.decrypt(data, cryptoKey).toString(cryptoJs.enc.Utf8);
}

module.exports = Decrypt;